import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

let toggleIdCounter = 0;

@Component({
  selector: 'ebo-toggle',
  templateUrl: './ebo-toggle.component.html',
  styleUrls: ['./ebo-toggle.component.scss']
})
export class EboToggleComponent implements OnInit {
  @Input() label: string;
  @Input() style: 1;
  @Input() hint = '';
  @Input() disabled = false;
  @Input() control: FormControl;

  toggleId = `ebo-toggle-${++toggleIdCounter}`;

  ngOnInit(): void {
    // Initialize with control value if provided
    if (this.control && this.control.value === undefined) {
      this.control.setValue(false);
    }
  }

  onToggleChange(event: any): void {
    if (this.control) {
      this.control.setValue(event.checked);
      this.control.markAsTouched();
    }
  }
}
